import { Redirect } from "wouter";
import { useGetCurrentUser } from "@workspace/api-client-react";
import SetupProfile from "@/pages/setup-profile";
import { useAuth } from "@clerk/react";
import { loadPending } from "@/lib/freeSignup";

export default function ProfileSetupGuard({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useGetCurrentUser();
  const { userId } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-muted-foreground font-mono text-sm animate-pulse">Loading...</div>
      </div>
    );
  }

  if (data && !data.isAdmin && data.members.length === 0) {
    // #81 F2 (Dex's finding, Sean's recommendation, Kayla's ruling) — PeakCommerce's Free journey
    // returns through a per-ENVIRONMENT button to /dashboard, not to a per-journey path. A runner who
    // left mid-action (join / claim) for the Free journey comes back here with no profile yet; send
    // them to /account/setting-up, which waits for the subscription and replays the action, instead
    // of the chooser (where they would have to start over). No pending action = the chooser, as before.
    // Only THIS account's pending action counts (!139): another account's never redirects here.
    if (loadPending(userId)) return <Redirect to="/account/setting-up" replace />;
    return <SetupProfile startOnCreate={data.canCreateSquad} />;
  }

  return <>{children}</>;
}
